import React from 'react'
import { M_Table } from 'src/components/M_Components'

export default function Status({ roles }) {

    return (
        <M_Table entityName={'ServiceOrderState'} filtersOnTable rolePermissions={roles} />
    )
}